/* eslint-disable */
import { defaultApiInstance } from '@/compositions/api';

export function getChangeLogList(params) {
  return defaultApiInstance.get(`v1/changeLog`, { params });
}
